import { createAsyncThunk } from '@reduxjs/toolkit';
import { set } from 'lodash';
import { client } from '../../../api';

export const editFundingGroupThunk = createAsyncThunk('fundingGroups.editFundingGroup', async (payload, { rejectWithValue }) => {
  const URL = `/funding/${payload.fundingGroupId}`;
  try {
    const { data, status, statusText } = await client.put(URL, payload);
    return { ...data, status, statusText };
  } catch (err) {
    const { data, status, statusText } = err.response;
    return rejectWithValue({ ...data, status, statusText });
  }
});

export const addFundingGroupReducers = {
  [editFundingGroupThunk.fulfilled]: (state, { payload }) => {
    set(
      state,
      'isLoading',
      false,
    );
    set(
      state,
      'editingFundingGroup',
      payload,
    );
  },
  [editFundingGroupThunk.pending]: (state) => {
    set(
      state,
      'isLoading',
      true,
    );
  },
  [editFundingGroupThunk.rejected]: (state, { payload }) => {
    set(
      state,
      'isLoading',
      false,
    );
    set(
      state,
      'editingFundingGroup',
      payload,
    );
  },
};
